import { FC } from "react";
import { Tabs } from "@rothoblaas/design-system";
import useI18n from "../../../../../hooks/useTranslations";
import Admin3DModelsTab from "../Admin3DModelsTab";
import AdminFastenerUsagesTab from "../AdminFastenerUsagesTab";
import AdminLockAccessoriesTab from "../AdminLockAccessoriesTab";
import AdminLockLockstopMappingsTab from "../AdminLockLockstopMappingsTab";
import AdminLockModulesTab from "../AdminLockModulesTab";
import AdminLockPairLockstopMappingsTab from "../AdminLockPairLockstopMappingsTab";
import AdminLocksTab from "../AdminLocksTab";
import AdminLockStopsTab from "../AdminLockStopsTab";

const AdminLocksCatalogTab: FC = () => {
  const { translation: t } = useI18n();

  return (
    <Tabs.SubTab>
      <Tabs renderMode="eager"
        urlParameter="connectors_tab"
        tabs={[
          { title: t.lockCalculatorModule.admin.connectors.singular },
          { title: t.lockCalculatorModule.admin.lockModules.singular },
          { title: t.lockCalculatorModule.admin.lockStops.singular },
          { title: t.lockCalculatorModule.admin.connectorAccessories.singular },
          { title: t.lockCalculatorModule.admin.lockLockstopMappings.singular },
          { title: t.lockCalculatorModule.admin.lockPairLockstopMappings.singular },
          { title: t.lockCalculatorModule.admin.model3d.singular },
          { title: t.lockCalculatorModule.admin.fastenerUsages.singular },
        ]}
        contents={[
          <AdminLocksTab />,
          <AdminLockModulesTab />,
          <AdminLockStopsTab />,
          <AdminLockAccessoriesTab />,
          <AdminLockLockstopMappingsTab />,
          <AdminLockPairLockstopMappingsTab />,
          <Admin3DModelsTab />,
          <AdminFastenerUsagesTab />,
        ]}
      />
    </Tabs.SubTab>
  );
};

export default AdminLocksCatalogTab;
